import { motion } from 'framer-motion';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import ButtonComponent from 'components/Button/Button';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

export const JoinUsInternshiOverlayWrapper = styled.div`
  grid-column: 1/-1;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(12, [content] minmax(0px, 1fr))
    [out-right] 16px;
  margin-bottom: 120px;

  ${mediaDesktop(`
    margin-bottom: 180px;
    grid-template-columns: [out-left] 124px repeat(12, [content] minmax(0px, 1fr)) [out-right] 124px;
  `)}
`;

export const Header = styled.div`
  grid-column: 2/-2;

  ${mediaDesktop(css`
    grid-column: 2/7;
  `)}
`;

export const Title = styled.div`
  margin-bottom: 20px;

  ${mediaDesktop(css`
    margin-bottom: 28px;
  `)}
`;

export const Description = styled.div`
  margin-bottom: 72px;

  ${mediaDesktop(css`
    margin-bottom: 86px;
  `)}
`;

export const TypesWrapper = styled.div`
  position: relative;
  grid-column: 2/-2;

  ${mediaDesktop(css`
    grid-column: 2/6;
  `)}
`;

export const IntenshipTypeImage = styled(motion.img)`
  display: none;
  margin-left: 60px;
  max-width: 100%;

  ${mediaDesktop(css`
    display: inline-block;
    grid-column: 7/-2;
  `)}
`;

const sharedPseudoElement = css`
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  top: 0;
`;

export const AccordionHeader = styled.div<{ isOpen: any; titleColors: string }>`
  position: relative;

  overflow: hidden;

  &::after {
    ${sharedPseudoElement}
    background-color: rgba(255, 255, 255, 0.5);
  }

  &::before {
    ${sharedPseudoElement}
    background-color: rgba(255, 255, 255, 0.8);
    transform: translateX(-100%);
    z-index: ${layout.zIndex.overContent};
    transition: transform 0.8s cubic-bezier(0.04, 0.62, 0.23, 0.98);
  }

  p {
    color: ${rgba(colors.white, 1)};
    padding: 20px 0;
    cursor: pointer;
  }

  & > p {
    color: ${({ titleColors }) =>
      rgba((colors[titleColors] ?? titleColors) || colors.white, 1)};
  }

  ${({ isOpen, titleColors }) =>
    !isOpen &&
    css`
      p {
        color: ${rgba(colors.white, 1)};
      }

      &:hover > p {
        color: ${rgba((colors[titleColors] ?? titleColors) || colors.white, 1)};
      }

      &:hover {
        &::before {
          transform: translateX(0);
        }
      }
    `};
`;

export const AccordionItem = styled(motion.section)`
  div {
    padding-bottom: 16px;
    width: 90%;
  }

  img {
    margin: 40px 0 28px 0;
    width: calc(100vw - 32px);
    height: 56.25vw;
  }

  ${mediaDesktop(css`
    img {
      display: none;
    }

    div {
      padding-bottom: 40px;
    }
  `)}
`;

export const Button = styled(ButtonComponent)``;

export const ButtonWrapper = styled.div`
  margin-top: 48px;
  grid-column: 2 / -2;

  ${mediaDesktop(
    css`
      grid-column: 2 / 5;
    `
  )}
`;
